// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q4dLaH7iAicHaQzys5n5{justify-content:space-between;align-items:center;gap:12px;width:100%;display:flex}.q4dLaH7iAicHaQzys5n5 .CZG3lJrKOOs3ODEt52Sh{align-items:center;display:flex}.q4dLaH7iAicHaQzys5n5 .p9ygbqUklYA6aBdzRv83{gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `q4dLaH7iAicHaQzys5n5`,
	"flex": `CZG3lJrKOOs3ODEt52Sh`,
	"row8": `p9ygbqUklYA6aBdzRv83`
};
export default ___CSS_LOADER_EXPORT___;
